import { object, string, array, boolean, number, date } from 'yup';

export default object().shape({
  name: string().required(),
  type: string().required(),
  amount: number().nullable().required(),
  isPercentage: boolean(),
  activeAt: date().nullable(),
  expiresAt: date().nullable(),
  priority: number().nullable(),
  vatSettings: array()
    .of(
      object().shape({
        type: string().required(),
        countryCode: object().required(),
        reference: object().nullable().required(),
      }),
    )
    .required(),
});
